import React from 'react'

const Avatar = ({ firstName, surname, className = '' }) => {
  const initials = `${firstName?.[0] ?? ''}${surname?.[0] ?? ''}`.toUpperCase()
  return <div className={`avatar${className ? ` ${className}` : ''}`}>{initials}</div>
}

export default Avatar
